<h2 mat-dialog-title class="mb-0">Promote to {{ useBrandivioBranding ? 'Company' : 'Pattern' }} board</h2>
<button mat-flat-button [mat-dialog-close] mat-dialog-close>
    <img src="assets/icon-close.svg" width="14" height="auto" alt="close button" />
</button>

<div class="board-promote">
    <p class="board-promote__intro">
        This moves <strong>{{ data.boardData.board_name }}</strong> out of My Boards and into
        {{ useBrandivioBranding ? 'Company' : 'Pattern' }} boards, where everyone can see it. It will no longer appear
        under My Boards.
    </p>

    <mat-form-field class="board-promote__field" [floatLabel]="'always'">
        <mat-label>{{ useBrandivioBranding ? 'Company' : 'Pattern' }} board name</mat-label>
        <input matInput [(ngModel)]="boardName" placeholder="Board name" required cdkFocusInitial />
    </mat-form-field>
</div>

<mat-dialog-actions align="center">
    <button mat-stroked-button color="accent" [mat-dialog-close] class="mr-3" mat-dialog-close>Cancel</button>
    <!-- Stroked, not flat: a flat button inside .mat-dialog-container is absolutely positioned
         top-right by the dashboard styles, which is reserved for the close icon. -->
    <button mat-stroked-button color="accent" [disabled]="!boardName" (click)="promoteBoard()">Promote</button>
</mat-dialog-actions>
